import {
    assistantAsking, assistantAskingForAction, assistantAskingForExample,
    assistantAskingForGenre, assistantAskingForInstructions, assistantAskingForRequirements, assistantAskingForSchema,
    assistantAskingForSynopsis,
    systemInstruction, userSaying
} from "../../../../../../../ai/Utils";


export const generateTitlePrompt = (vars: {
    genres: string[],
    synopsis: string
}) => systemInstruction("Ты профессиональный писатель")
    .concat(userSaying("Я работаю над созданием литературного произведения"))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAskingForRequirements([
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": {"title":string}'))
    .concat(assistantAskingForExample({
        data: {
            title: "В новогоднюю ночь"
        }
    }))
    .concat(assistantAskingForAction(`Сгенерируй название произведения.`))

export const generateSynopsisPrompt = (vars: {
    genres: string[],
    idea: string,
}) => systemInstruction("Ты профессиональный писатель")
    .concat(userSaying("Я работаю над созданием литературного произведения"))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAsking("Опиши идею произведения", vars.idea))
    .concat(assistantAskingForInstructions([
        "Придумай сюжет",
        "Проработай сюжет",
        "Придумай название"
    ]))
    .concat(assistantAskingForRequirements([
        "Должны присутствовать завязка, кульминация и развязка, разбитые на абзацы",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": {"title":string, "synopsis":string}'))
    .concat(assistantAskingForExample({
        data: {
            title: "В новогоднюю ночь",
            synopsis: "В ночь на 31 декабря главный герой отправляется в поход и находит магический артефакт"
        }
    }))
    .concat(assistantAskingForAction(`Сгенерируй подробный синопсис`))